import { CanActivate, Router, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { Global } from "./classes/Global";
import { InternationalizationHelper } from "./helpers/InternationalizationHelper";

@Injectable()
export class RedirectGuard implements CanActivate {
  constructor(
    private router: Router
  ) {}

  canActivate(routeSnapshot: ActivatedRouteSnapshot): boolean {

    let routePath = routeSnapshot.routeConfig.path;
    if (routePath == ":country/" + InternationalizationHelper.getString('onSaleUrl')) {
        const country = routeSnapshot.params && routeSnapshot.params.country ? routeSnapshot.params.country : Global.getCountry();
        const store = Global.supportedCountries[Global.getStore()] && Global.supportedCountries[Global.getStore()][country] ? Global.getStoreUrl() : Global.DEFAULT_STORE;
        const newUrl = country + "/" + store + "/" + Global.getMediaTypeForUrl() + "/" + InternationalizationHelper.getString("onSaleUrl");
        this.router.navigate([newUrl], { replaceUrl: true });
        console.log("redirect guard", routePath, newUrl);
        return false;
    }

    return true;
  }
}  